import React from 'react';
import { CartIcon } from '@chegg-ui/theme';
import { getSignedInNavItems } from '../../../externals.retrofit';
import { MobileButtonsContainer, CartLink } from '../../../styles';
import HeaderLogoLink from '../../HeaderLogoLink.retrofit';
import { getSecondaryNavLinks } from '../../getSecondaryNavLinks.retrofit';
import MobileHamburgerMenu from './MobileHamburgerMenu';

var MobileHeader = function MobileHeader(_ref) {
  var navType = _ref.navType,
      envUrl = _ref.envUrl,
      cartCount = _ref.cartCount,
      user = _ref.user,
      userCourses = _ref.userCourses,
      activeSubLink = _ref.activeSubLink,
      onClickSignOut = _ref.onClickSignOut,
      userDataLoading = _ref.userDataLoading;
  var navLinks = getSignedInNavItems(navType, userCourses, true);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MobileHamburgerMenu, {
    envUrl: envUrl,
    navLinks: navLinks,
    user: user,
    activeSubLink: activeSubLink,
    userDataLoading: userDataLoading // TODO infra: memoize links? https://chegg.atlassian.net/browse/CUI-368
    ,
    userLinks: getSecondaryNavLinks({
      navType: navType,
      onClickSignOut: onClickSignOut
    })
  }), /*#__PURE__*/React.createElement(HeaderLogoLink, {
    envUrl: envUrl
  }), /*#__PURE__*/React.createElement(MobileButtonsContainer, null, !userDataLoading && cartCount && cartCount >= 0 ? /*#__PURE__*/React.createElement(CartLink, {
    href: "".concat(envUrl, "shoppingcart"),
    "data-test": "header-cart"
  }, /*#__PURE__*/React.createElement(CartIcon, {
    size: "medium",
    numItems: cartCount
  })) : null));
};

MobileHeader.displayName = 'MobileHeader';
export default MobileHeader;